import styles from './BuiltByBert.module.scss';

/**
 * BuiltByBert logo — simple white text.
 * Positioned fixed in the bottom-left corner.
 */
const BuiltByBert = () => {
  return (
    <div className={styles.root} style={{ bottom: '40px', left: '8px' }}>
      Built By Bert
    </div>
  );
};

export { BuiltByBert };
